import * as React from "react";
import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const features = ["Fliesen und Mosaik", "Marmor, Granit, Naturstein", "Fensterbänke", "Untergrundvorbereitung"];
export default function ServicesGridFliesenPlattenUndMosaikleger() {
  return <section id="services-grid-fliesen-platten-und-mosaikleger" className="py-12 md:py-16 bg-background">
      <div className="page-container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          
          {}
          <div className="flex flex-col gap-6 md:gap-8">
            <div className="space-y-4">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold text-foreground leading-tight">Fliesen &amp; Naturstein</h2>
              <p className="text-lg text-muted-foreground leading-relaxed max-w-xl">
                Fachmännische Verlegung von Fliesen, Mosaik und Naturstein. Wir bereiten den Untergrund vor und sorgen für ein perfektes Ergebnis.
              </p>
            </div>

            <ul className="flex flex-col gap-3.5">
              {features.map((feature, i) => <li key={i} data-index={i} className="flex items-center gap-3">
                  <Check className="w-5 h-5 text-primary shrink-0" strokeWidth={2} />
                  <span className="text-base md:text-lg text-foreground">
                    {feature}
                  </span>
                </li>)}
            </ul>

            <div className="pt-2">
              <Button asChild size="lg" className="rounded-lg px-8 text-base">
                <Link to="/ContactPage">Angebot anfordern</Link>
              </Button>
            </div>
          </div>

          {}
          <div className="relative w-full aspect-[4/3] lg:aspect-[4/3] rounded-2xl overflow-hidden shadow-lg">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675284/img/fliesenleger_service_hero.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675284/img/fliesenleger_service_hero.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675284/img/fliesenleger_service_hero.png-wvc-sizes" alt="Handwerker verlegt weiße Fliesen im Fischgrätmuster" className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
          </div>

        </div>
      </div>
    </section>;
}